import { ERROR, START, SUCCESS } from "../../../../constants/action-postfix";
import { PERFORMANCE_REQUEST } from "../performanceReducer";


const initialState = false;

export const loaderReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${PERFORMANCE_REQUEST}${START}`:
            return true;
        case `${PERFORMANCE_REQUEST}${SUCCESS}`:
            return false;
        case `${PERFORMANCE_REQUEST}${ERROR}`:
            return false;
        default:
            return state;
    }
};
